import { PropertyConverter } from 'angular2-jsonapi'
import { VersaoDesktopJson } from '../controle-versao/versao-deskptop-json.interface'
import { VersaoDesktop } from '../controle-versao/versao-desktop'

export class VersoesDesktopConverter implements PropertyConverter {
    mask(value: string) {
        const objArray = JSON.parse(value) as VersaoDesktopJson[]

        return objArray.map(obj => new VersaoDesktop(obj))
    }

    unmask(versoesDesktop: VersaoDesktop[]) {
        if (typeof versoesDesktop === 'string') {
            return versoesDesktop
        }

        const objArray = versoesDesktop.map(v => {
            return {
                Sistema: v.sistema,
                Versao: v.numero.join('.')
            } as VersaoDesktopJson
        })

        return JSON.stringify(objArray)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/converters/versoes-desktop.converter.ts